<template>
  <c-modal title="New user" :show="show" @update:show="toggle">
    <c-form>
      <c-input
        v-model="firstName"
        label="First name"
        placeholder="Enter first name"
        :is-valid="checkIfValid('firstName')"
        invalid-feedback="Please enter a first name"
      />
      <c-input
        v-model="lastName"
        label="Last name"
        placeholder="Enter last name"
        :is-valid="checkIfValid('lastName')"
        invalid-feedback="Please enter a last name"
      />
      <c-select
        :options="roles"
        label="Role"
        :value="role"
        :is-valid="checkIfValid('role')"
        invalid-feedback="Please select a role"
        @update:value="
          e => {
            this.role = e;
          }
        "
      />
      <c-input
        v-model="email"
        label="Email"
        placeholder="Enter user email"
        :is-valid="checkIfValid('email')"
        invalid-feedback="Please enter an email in the format email@domain.com"
      />
    </c-form>
    <template v-slot:footer>
      <c-button-group>
        <c-button color="primary" @click="addUser">
          <c-spinner v-if="isAddingUser" color="success" size="sm" />
          <span v-else>Add</span>
        </c-button>
        <c-button v-if="!isAddingUser" color="secondary" @click="close">Cancel</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'NewUser',
  mixins: [validationMixin],
  props: {
    show: Boolean,
    organisation: Object,
  },
  data() {
    return {
      organisationId: null,
      isAddingUser: false,
      firstName: '',
      lastName: '',
      role: '',
      email: '',
    };
  },
  validations: {
    firstName: {
      required,
    },
    lastName: {
      required,
    },
    role: {
      required,
    },
    email: {
      required,
      email,
    },
  },
  computed: {
    isValid() {
      return !this.$v.$invalid;
    },
    roles() {
      const items = this.$store.state.app.clientRoles.map((role) => ({
        value: role.key,
        label: role.name,
      }));
      items.unshift({
        value: '',
        label: 'Select role',
      });
      return items;
    },
  },
  mounted() {
    this.organisationId = this.$route.params.organisationId;
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === '');
    },
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
    close() {
      this.reset();
      this.$emit('close');
    },
    reset() {
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.role = '';
      this.$v.$reset();
    },
    addUser() {
      this.$v.$touch();
      if (!this.isValid) {
        return;
      }
      this.isAddingUser = true;
      const data = {
        firstName: this.firstName,
        lastName: this.lastName,
        role: this.role,
        username: this.email,
      };
      this.$http
        .post(buildEndpoint('organisation-admin/organisation/users/new'), data)
        .then((response) => {
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: `New user added. Confirmation email sent to ${this.email}.`,
            });
            this.$emit('added');
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        })
        .finally(() => {
          this.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped=""></style>
